export enum TransactionSourceEnum {
    Main = 1,
    Shareholders = 2,
    Traders = 3
}
